import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';

/**
 * Tiene fuori dalle schermate chi non ha una sessione.
 *
 * Prima le rotte non avevano guardie: aprendo l'indirizzo di un articolo senza
 * essere entrati si disegnava l'editor completo, vuoto, sopra tre risposte 401.
 * I dati erano al sicuro — li protegge l'API — ma la pagina non serviva a
 * niente e sembrava rotta.
 *
 * Il controllo non si ferma alla presenza del token: un token scaduto c'e' ma
 * non vale, e si scopre solo quando `me` risponde.
 */
export const autenticato: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigateByUrl('/');
    return false;
  }

  const utente = await authService.attendiUtente();
  if (!utente) {
    router.navigateByUrl('/');
    return false;
  }

  return true;
};
